import { RouteRecordRaw } from "vue-router";

const routes: RouteRecordRaw = {
  path: '/login',
  name: 'login',
  component: () => import("@/modules/auth/views/Login.vue")
}

export default routes